import { Button } from '@acpaas-ui/react-components';
import { indexOf } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReset } from '../../../actions/fetch.actions';
import {
  ADMIN_CONTACT_CITY,
  ADMIN_CONTACT_PARTNER,
  ADMIN_CONTACT_SCHOOL
} from '../../../constants/admin.contacts.constants';
import { MODALS } from '../../../constants/modals.constants';
import { ALL_SELECT_OPTION } from '../../../constants/settings.constants';
import StaticTable from '../../../containers/core/StaticTable';
import { useForm } from '../../../hooks/useForm.hook';
import { useModal } from '../../../hooks/useModal.hook';
import { mapOrganizationRole } from '../../../lib/contact.utils';
import ContactOrganizationModalContainer from '../../../modals/admin/ContactOrganizationModalContainer';
import { ADMIN_CONTACT_PARTNER_ORGANIZATIONS_RESOURCE } from '../../../resources/admin/admin.contact.partner.organizations.resource';
import { ADMIN_CONTACT_SCHOOL_ORGANIZATIONS_RESOURCE } from '../../../resources/admin/admin.contact.school.organizations.resource';
import { currentUserSelector } from '../../../selectors/auth.selectors';

const DEFAULT_STATE = {
  net: '',
  management: '',
  community: '',
  school: '',
  branch: '',
  organization: '',
  function: '',
  role: '',
  entityId: ''
};

const AdminContactOrganizationsFields = ({
  type,
  isEdit,
  canUpdate,
  onAdd,
  onUpdate,
  onDelete,
  roles,
  isSubmitting
}) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector);
  const addContactOrganizationModal = useModal(MODALS.ADD_CONTACT_ORGANIZATION_MODAL);
  const updateContactOrganizationModal = useModal(MODALS.UPDATE_CONTACT_ORGANIZATION_MODAL);
  const { data, input, load } = useForm(DEFAULT_STATE);

  if (!type || type === ADMIN_CONTACT_CITY) {
    return null;
  }

  const resource =
    type === ADMIN_CONTACT_SCHOOL
      ? ADMIN_CONTACT_SCHOOL_ORGANIZATIONS_RESOURCE
      : ADMIN_CONTACT_PARTNER_ORGANIZATIONS_RESOURCE;

  const handleOpenAddClick = () => {
    load({
      ...DEFAULT_STATE,
      isApproved: type === ADMIN_CONTACT_SCHOOL && currentUser?.type === ADMIN_CONTACT_PARTNER ? false : true
    });
    addContactOrganizationModal.onOpen();
  };

  const handleOpenUpdateClick = (data) => {
    const role = roles?.find((r) => r?.treePath === data?.treePath);
    const [netId, managementId, communityId, schoolId, branchId] = role?.treePath?.split('#') ?? [];
    load({
      ...role,
      organization: netId || '',
      net: netId || '',
      management: managementId || ALL_SELECT_OPTION.value,
      community: communityId || ALL_SELECT_OPTION.value,
      school: schoolId || ALL_SELECT_OPTION.value,
      branch: branchId || ALL_SELECT_OPTION.value,
      index: indexOf(roles, role)
    });
    updateContactOrganizationModal.onOpen();
  };

  const handleAddConfirm = () => {
    onAdd(mapOrganizationRole({ ...data, index: roles?.length || 0 }, type));
    dispatch(fetchReset(resource));
    addContactOrganizationModal.onClose();
    load(DEFAULT_STATE);
  };

  const handleUpdateConfirm = () => {
    onUpdate(mapOrganizationRole(data, type));
    dispatch(fetchReset(resource));
    updateContactOrganizationModal.onClose();
    load(DEFAULT_STATE);
  };

  const handleDelete = () => {
    onDelete(data?.index);
    dispatch(fetchReset(resource));
    updateContactOrganizationModal.onClose();
    load(DEFAULT_STATE);
  };

  return (
    <div className="u-margin-top">
      <StaticTable
        responsive
        resource={resource}
        onRowClick={canUpdate ? handleOpenUpdateClick : undefined}
        data={roles}
        actions={
          canUpdate
            ? [
                <Button
                  key="add-contact-organization"
                  iconRight="ai-add"
                  size="small"
                  className="u-margin-right-xs"
                  disabled={isSubmitting}
                  onClick={handleOpenAddClick}
                >
                  Organisatie toevoegen
                </Button>
              ]
            : []
        }
      />
      <ContactOrganizationModalContainer
        addModal={addContactOrganizationModal}
        updateModal={updateContactOrganizationModal}
        type={type}
        onInput={input}
        onAdd={handleAddConfirm}
        onUpdate={handleUpdateConfirm}
        onDelete={handleDelete}
        data={data}
        isEdit={isEdit}
      />
    </div>
  );
};

export default AdminContactOrganizationsFields;
